import { render } from "./XshdList.vue?vue&type=template&id=f1aae968&scoped=true&ts=true"
import script from "./xshdListHelper.ts?vue&type=script&lang=ts"
export * from "./xshdListHelper.ts?vue&type=script&lang=ts"

import "./XshdList.vue?vue&type=style&index=0&id=f1aae968&scoped=true&lang=css"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1aae968"]])

export default __exports__